<template>
  <div class="groupProduct">
    <div class="screen">
      <!-- <router-link :to="{ path: '/apply/GoodsGroup/4/createGroup' }"> -->
      <el-button type="primary" size="small">添加商户</el-button>
      <!-- </router-link> -->
      <div class="floatrgt">
        <el-select v-model="value" placeholder="请选择" size="small">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select v-model="value" placeholder="请选择" size="small">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select v-model="value" placeholder="请选择" size="small">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input v-model="input" placeholder="请输入内容" size="small"></el-input>
        <el-button type="primary" size="small">查询</el-button>
      </div>
    </div>
    <template>
      <div class="tables">
        <template>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="编号" min-width="140"></el-table-column>
            <el-table-column prop="name" label="客户名称" min-width="140"></el-table-column>
            <el-table-column prop="name" label="状态" min-width="140"></el-table-column>
            <el-table-column prop="name" label="商户类型" min-width="140"></el-table-column>
            <el-table-column prop="name" label="账户余额" min-width="140"></el-table-column>
            <el-table-column prop="name" label="联系人" min-width="140"></el-table-column>
            <el-table-column prop="name" label="统计" min-width="140"></el-table-column>
            <el-table-column prop="name" label="开启优选" min-width="140"></el-table-column>
            <el-table-column prop="name" label="操作" min-width="140"></el-table-column>
          </el-table>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "1",
      tableData: [],
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: ""
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.groupProduct {
  width: 100%;
  padding: 15px 25px;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
  .el-select {
    width: 100px;
  }
  .screen {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 25px;
    .el-button,
    .el-select,
    .el-input {
      margin-right: 10px;
    }
    .el-input {
      width: 200px;
    }
  }
  .tables {
    width: 100%;
    border: 1px solid #ebeef5;
  }
}
</style>

<style lang="scss">
.groupProduct {
  .cell {
    text-align: center;
  }
}
</style>
